// ============================================================
// Warehouse export — file encoders
//
//   ndjson.gz  one flat JSON row per line, gzip (CompressionStream)
//   parquet    hyparquet-writer (pure JS, snappy), typed columns
// ============================================================
import { parquetWriteBuffer } from 'hyparquet-writer';
import { WAREHOUSE_COLUMNS, EXPORT_SCHEMA_VERSION } from './rows.js';
export const EXPORT_FORMATS = ['ndjson.gz', 'parquet'];
const enc = new TextEncoder();
export function ndjsonBytes(rows) {
    return enc.encode(rows.map(r => JSON.stringify(r)).join('\n') + (rows.length ? '\n' : ''));
}
export async function gzip(data) {
    const stream = new Blob([data]).stream().pipeThrough(new CompressionStream('gzip'));
    return new Uint8Array(await new Response(stream).arrayBuffer());
}
export function parquetBytes(rows) {
    const typeOf = {
        string: 'STRING',
        float: 'DOUBLE',
        bool: 'BOOLEAN',
        timestamp: 'TIMESTAMP',
        json: 'JSON',
    };
    const columnData = WAREHOUSE_COLUMNS.map(col => ({
        name: col.name,
        type: typeOf[col.type],
        data: rows.map(r => {
            const v = r[col.name];
            if (v === null || v === undefined) {
                return null;
            }
            if (col.type === 'timestamp') {
                return new Date(String(v));
            }
            // The writer serialises JSON columns itself.
            return col.type === 'json' ? JSON.parse(String(v)) : v;
        }),
    }));
    const buf = parquetWriteBuffer({
        // hyparquet-writer's column typing is looser than its declared union.
        columnData: columnData,
        kvMetadata: [{ key: 'yom.export_schema_version', value: String(EXPORT_SCHEMA_VERSION) }],
    });
    return new Uint8Array(buf);
}
export async function encodeRows(rows, format) {
    if (format === 'parquet') {
        return {
            body: parquetBytes(rows),
            contentType: 'application/vnd.apache.parquet',
            extension: 'parquet',
        };
    }
    return {
        body: await gzip(ndjsonBytes(rows)),
        // Served as a .gz object (no Content-Encoding) so warehouses read it as compressed NDJSON.
        contentType: 'application/x-ndjson',
        extension: 'ndjson.gz',
    };
}
//# sourceMappingURL=encode.js.map